import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

type Landlord = {
  last_login?: string | null
  landlord_invited_at?: string | null
}

const formatInviteDate = (value: string) =>
  new Date(value).toLocaleDateString('sk-SK')

/** Whether the landlord uses the portal yet: logged in, invited, or neither. */
export function LandlordAccountStatus({ landlord }: { landlord: Landlord }) {
  const { t } = useTranslation('users')

  const [label, tone] = landlord.last_login
    ? [t('landlordInvite.status.loggedIn'), 'bg-success-soft text-success']
    : landlord.landlord_invited_at
      ? [
          t('landlordInvite.status.invited', {
            date: formatInviteDate(landlord.landlord_invited_at)
          }),
          'bg-info-soft text-info'
        ]
      : [t('landlordInvite.status.notInvited'), 'bg-ink/[0.07] text-ink/60']

  return (
    <span
      className={cn(
        'inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold',
        tone
      )}
    >
      {label}
    </span>
  )
}
